enum GameState {
  RESOLVED,
  CANCELLED,
}
export enum TAResultCode {
  Topaz = 101,
  Emerald,
  Ruby,
  Wild_Collector,
  Great_Scavenger,
  Bens_Lost_Marbles,
  John_Silvers_Loot,
  Billy_Bones_Map,
  Captains_Flints_Treasure,
  Topaz_Topaz,
  Emerald_Emerald,
  Ruby_Ruby,
  Emerald_Topaz,
  Ruby_Topaz,
}
export enum GemCode {
  Topaz = 1,
  Emerald,
  Ruby,
}
export enum BallCodes {
  Bingo_Topaz = 301,
  Bingo_Emerald,
  Bingo_Ruby,
  Bingo_Black_Topaz,
  Bingo_Black_Emerald,
  Bingo_Black_Ruby,
}

export interface Gem {
  key: GemCode;
  val: string;
}

export interface GemsResultType {
  icon: string;
  multiplier: number | string;
}

export interface TAGameSummary {
  bonus: boolean;
  bonusCode: string;
  bonusDesc: string;
  gameState: GameState;
  gemsPayout: Gem[];
  multipliers: { gems: Gem[]; gs: Gem[] };
  payoutMul: string;
  resultCode: TAResultCode;
  resultDesc: string;
  wheelPosition: string;
  wcData?: { gems: { entry: { key: GemCode; value: string }[] } };
  marblesSummary?: {
    diceValues: string[];
    totalGems: Gem[];
    mul: Gem[];
    gemsCount: Gem[];
  };
  bingoSummary?: {
    bingo: Bingo[];
    gemsCount: Gem[];
    totalWeights: Gem[];
    bingoWeights: Array<Gem>;
  };
  captainFlintSummary?: { barrelsWon: CFTBarrel[]; gemsCount: Gem[] };
  mapSummary?: mapSummary;
  gemUpgradeFlag?: GemUpgradeFlag;
}

interface mapSummary {
  playerDecisions: BMMDecision[];
  gemsCount: Gem[];
  chestFound: string;
  chestPrize: string;
  chestType: string;
}

interface Bingo {
  code: string;
  place: string;
  points: string;
  weight: string;
}

export interface CFTBarrel {
  autoDecision: string;
  barrelType: CFTBarrelTypes;
  won: string;
  gem?: string;
  gemCount?: string;
}

export interface BMMDecision {
  autoDecision: string;
  mul: string;
  type: string;
}
export enum CFTBarrelTypes {
  gem = 'GEM',
  trap = 'TRAP',
  chest = 'CHEST',
  key = 'KEY',
}
export enum BMMDecisionTypes {
  topasz = 'TOPASZ',
  emerald = 'EMERALD',
  ruby = 'RUBY',
  chest = 'CHEST',
}

export interface GemUpgradeFlag {
  key: string;
  val: string;
}
